module.exports = __webpack_public_path__ + "static/media/convex.88bbe4ee.svg";